/* eslint-disable no-plusplus */

import { clearDate } from './date';

/**
 * Apply a mask to a string according to the pattern.
 * @param value
 * @param pattern "#" is wildcard
 * * E.g.:
 *  * value: 11233334444
 *  * pattern: (##) # ####-####
 *  * return: (11) 2 3333-4444
 */
export function maskString(value: string, pattern: string) {
  if (!value || !pattern) return '--';
  let i = 0;
  const v = value.toString();
  return pattern.replace(/#/g, (_) => v[i++]).replace(/undefined/g, '');
}

export function maskType99(value: string, pattern: string) {
  const aux = value.split('_')[0];
  return maskString(aux, pattern);
}

export function maskPhoneDDI(value: string) {
  return maskString(value, '### (##) #####-####');
}

export function maskPhoneDefault(value: string) {
  return maskString(value, '(##) #####-####');
}

export function maskCPF(value: string) {
  return maskString(value, '###.###.###-##');
}

export function maskRG(value: string) {
  return maskString(value, '##.###.###-#');
}

export function maskRG2(value: string) {
  return maskString(value, '##.###.###');
}

export function maskCNPJ(value: string) {
  return maskString(value, '##.###.###/####-##');
}

export function maskDOCUMENT(value: string) {
  return maskString(value, '##.###.###/####-##');
}

export function maskCEP(value: string) {
  return maskString(value, '#####-###');
}

export function maskBIRTHDATE(value: string) {
  return clearDate(value);
}

export function maskWITHDOCUMENT(value: string) {
  return maskString(
    value,
    value.length > 10 ? '##.###.###-###' : '###.###.###-#',
  );
}

export function maskDEFAULT(value: string) {
  return value;
}
export const TYPE_MASK = {
  0: maskCPF,
  1: maskRG,
  2: maskBIRTHDATE,
  4: maskPhoneDDI,
  5: maskCEP,
  99: maskWITHDOCUMENT,
};
